import React from "react";
import { connect } from "react-redux";
import { getters } from "EventLight/Sessions/PortalSessionModal/model";

import Body from "./Body";
import Footer from "./Footer";
import StyleWrapper from "components/Global/Modal/Layout/StyleWrapper";
import Loading from "ui-kit/Loading";

import CustomHeader from "./CustomHeader";
import Header from "./Header";

const decorate = connect(state => ({
  sessionId: getters.sessionId(state),
  loading: getters.loading(state)
}));

const Layout = ({ hideModal, handlers, loading, sessionId }) => (
  <>
    <StyleWrapper
      hideHeader
      bodyStyles={{ padding: 0 }}
      containerStyles={{
        overflowY: "hidden",
        marginTop: 0,
        alignItems: "flex-start"
      }}
      hideModal={hideModal}
      width={1000}
    >
      <CustomHeader hideModal={hideModal} />
      <Header hideModal={hideModal} />
      {loading || !sessionId ? <Loading /> : <Body />}
      <Footer handlers={handlers} />
    </StyleWrapper>
  </>
);

export default decorate(Layout);
